import React from 'react';
import Layout from '../components/layout/Layout';

const RefundPage = () => {
  return (
    <Layout>
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Return & Refund Policy</h1>
          <p className="text-gray-300">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Product Returns</h2>
          <p className="text-gray-600 mb-6">
            We accept returns of STEAM-IE kits within 7 days of delivery if the product is unused, 
            unopened, and in its original packaging. To initiate a return, please contact us with your 
            order details.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Refund Eligibility</h2>
          <p className="text-gray-600 mb-4">Refunds are applicable for:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Defective or damaged products (reported within 48 hours of delivery)</li>
            <li>Wrong product delivered</li>
            <li>Unused products returned within 7 days</li>
            <li>Cancelled orders before dispatch</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Non-Refundable Items</h2>
          <p className="text-gray-600 mb-4">The following are not eligible for refunds:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Opened or used kits</li>
            <li>Digital products and online courses once accessed</li>
            <li>Certification fees after examination</li>
            <li>Custom or personalized orders</li>
            <li>Products damaged due to misuse</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Refund Process</h2>
          <p className="text-gray-600 mb-6">
            Once we receive and inspect the returned item, we will notify you of the refund status. 
            Approved refunds will be processed within 7-10 business days to the original payment method.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Program Cancellation</h2>
          <p className="text-gray-600 mb-6">
            For educational programs and workshops:<br />
            - Full refund if cancelled 7+ days before start date<br />
            - 50% refund if cancelled 3-7 days before start date<br />
            - No refund if cancelled less than 3 days before start date
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Shipping Costs</h2>
          <p className="text-gray-600 mb-6">
            Original shipping costs are non-refundable unless the return is due to our error. 
            Customers are responsible for return shipping costs unless the product was defective or incorrect.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Contact for Refunds</h2>
          <p className="text-gray-600 mb-6">
            To request a refund or report an issue:<br />
            Email: info@steamie.net<br />
            Phone: +91 79966 97777<br />
            Please include your order number and reason for the refund request.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default RefundPage;
